module.exports = __webpack_public_path__ + "public/media/img_smallmove_guide.7df85754.jpg";